export default function QR() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="rgba(0, 0, 0, 0.9)">
      <path d="M4.5 6V4.5H6V6H4.5Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.5 1.5H9V9H1.5V1.5ZM3 3V7.5H7.5V3H3Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path d="M4.5 19.49V18.02H6V19.49H4.5Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 15H1.5V22.5H9V15ZM3 21V16.5H7.5V21H3Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path d="M18 6V4.5H19.5V6H18Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.5 1.5H15V9H22.5V1.5ZM16.5 7.5V3H21V7.5H16.5Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path
        d="M10.5 12.02V16.5H12V15H13.5V13.5H12V12.02H10.5Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 10.5V9H12V7.51H13.5V10.5H10.5ZM13.5 10.5H16.5V12H13.5V10.5Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path
        d="M12 6V7.51H10.5V1.5H13.5V3H12V4.5H13.5V6H12Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path d="M16.5 16.5H15V13.5H16.5V16.5Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 16.5H16.5V21H15V22.5H16.5V21H21V22.5H22.5V21H21V19.5H22.5V18.02H21V16.5ZM18 18V19.5H19.5V18H18Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path d="M21 16.5V13.5H22.5V16.5H21Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path
        d="M15 16.5V19.5H13.5V22.5H10.5V21H12V19.5H10.5V18.02H12V19.49H13.5V16.5H15Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path d="M18 13.5V14.97H19.5V13.5H18Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path d="M1.5 12.02V13.49H3V12.02H1.5Z" fill="rgba(0, 0, 0, 0.9)"></path>
      <path
        d="M6 12H7.5V10.5H9V13.5H4.5V12H3V10.5H6V12Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
      <path
        d="M22.5 12H21V13.49H19.5V12H18V10.5H22.5V12Z"
        fill="rgba(0, 0, 0, 0.9)"
      ></path>
    </svg>
  );
}
